import React from 'react';
import { Tabs } from 'antd';
import { Loading } from '@components/common';
import LinkPane from './LinkPane';
import EmailPane from './EmailPane';
import * as CONSTANT from '../../constant';
import styles from './index.less';

const { TabPane } = Tabs;

const SharingContent = ({
  isFetching,
  url,
  id,
  hide,
  title,
  visible,
}) => {
  if (isFetching) {
    return (
      <Loading className={styles.loadingWrapper} />
    );
  }
  return (
    <div>
      <Tabs defaultActiveKey="link">
        <TabPane tab={CONSTANT.TAB_LINK} key="link">
          <LinkPane
            url={`${url}/${id}`}
            hide={hide}
          />
        </TabPane>
        <TabPane tab={CONSTANT.TAB_EMAIL} key="email">
          <EmailPane
            url={`${url}/${id}`}
            title={title}
            visible={visible}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SharingContent;
